import { useEffect, useState } from 'react';
import './news.css';

export default function News() {
    const [newsList, setNewsList] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch('http://185.164.73.170:5001/api/news')
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                const sortedData = data.sort((a, b) => b.id - a.id);
                setNewsList(sortedData);
                setLoading(false);
            })
            .catch((error) => {
                console.error('There was a problem with the fetch operation:', error);
                setLoading(false);
            });
    }, []);

    return (
        <div className='newspage'>
            {loading ? (
                <div className='loading-container'>
                    <div className='loading-spinner'></div>
                    <p>در حال بارگذاری...</p>
                </div>
            ) : (
                newsList.map((news) => (
                    <div className='news-card-page' key={news.id}>
                        <h2 className='news-title-page'>{news.title}</h2>
                        <p className='news-text-page'>{news.text}</p>
                        <p className='news-time-page'>{news.time}</p>
                    </div>
                ))
            )}
        </div>
    );
}
